import post1 from './post1';
import post2 from './post2';
import post3 from './post3';

const postData = [post3, post2, post1];

export default postData;
